import { Carousel } from "@domain/carousel/carousel";
import { ContentType } from "@domain/content/contentType";
import { Group } from "@domain/group/group";
import { Article } from "@domain/lms/article/article";
import { LightCourse } from "@domain/lms/course/course";
import { Quiz } from "@domain/lms/quiz/quiz";
import { Organization } from "@domain/organization/organization";
import { PostComment } from "@domain/post/comment/postComment";
import { Post } from "@domain/post/post";
import { Profile } from "@domain/user/profile";

export const allReportMotives = [
	"IDENTITY_THEFT",
	"FAKE_ACCOUNT",
	"HACKED",
	"SUICIDAL",
	"INAPPROPRIATE",
	"DECEASED",
	"CGU",
	"HATE_SPEECH",
	"FORBIDDEN_SALES",
	"DANGEROUS_ORGANIZATION",
	"HARASSEMENT",
	"FAKE_NEWS",
	"OTHER",
] as const;

export type ReportMotive = (typeof allReportMotives)[number];

export type ReportStatus = "PENDING" | "CONTENT_DELETED" | "IGNORED";
export interface ReportDraft {
	motive: ReportMotive;
	contentId: string;
	contentType: ContentType;
}
export interface ReportBase extends Omit<ReportDraft, "contentId"> {
	id: string;
	status: ReportStatus;
	reporter: Profile;
	date: Date;
}

export interface CourseReport {
	contentType: "COURSE";
	content?: LightCourse;
}

export interface ArticleReport {
	contentType: "ARTICLE";
	content?: Article;
}

export interface CarouselReport {
	contentType: "CAROUSEL";
	content?: Carousel;
}
export interface QuizReport {
	contentType: "QUIZ";
	content?: Quiz;
}
export interface PostReport {
	contentType: "POST";
	content?: Post;
}

export interface PostCommentReport {
	contentType: "POST_COMMENT";
	content?: PostComment;
}
export interface OrganizationReport {
	contentType: "ORGANIZATION";
	content?: Organization;
}
export interface GroupReport {
	contentType: "GROUP";
	content?: Group;
}
export interface UserReport {
	contentType: "USER";
	content?: Profile;
}

export type Report = ReportBase &
	(
		| CourseReport
		| ArticleReport
		| QuizReport
		| PostReport
		| PostCommentReport
		| OrganizationReport
		| GroupReport
		| UserReport
		| CarouselReport
	);
